export var DNCPendingStsMapper = function (resp) {
    if (resp)
        return {
            DNCStatus: resp.DNCStatus,
            StBrief: resp.StBrief,
            AcCode: resp.AcCode,
            Remark: resp.Remark,
        };
    return {};
};
